import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { PlayerNotificationsResponse } from '../../profile/models/currentPlayer.interface';
import { endpoints } from '../../utils/endpoints';
import { KeyValue } from '@angular/common';
import { MyRecord } from '../models/notification.interface';

@Injectable(
    {
        providedIn: 'root',
    }
)
export class ProfileNotificationsService {
    private http = inject(HttpClient);


    getAll(
        playerId: string,
        page: number,
        pageSize: number
    ): Observable<PlayerNotificationsResponse> {
        let query = new HttpParams();
        query = query.append('page', page);
        query = query.append('pageSize', pageSize);

        return this.http
            .get<PlayerNotificationsResponse>(
                endpoints.notifications.children.getNotificationsByPlayerId(
                    playerId
                ),
                {
                    params: query,
                }
            )
            .pipe(shareReplay());
    }

    markAsRead(notificationIds: string[]) {
        return this.http.put(
            endpoints.notifications.children.markAsReadNotification(),
            {
                notificationIds,
            }
        );
    }

    deleteNotification(notificationId: string) {
        return this.http.delete(
            endpoints.notifications.children.deleteNotification(notificationId)
        );
    }

    updateNotification(id: string, details: MyRecord) {
        return this.http.put(
            endpoints.notifications.children.updateNotificationDetails(id),
            {
                details,
            }
        );
    }
}
